'use es6';

import I18n from 'I18n';
export default (function () {
  return I18n.lang !== 'en' && !I18n.langEnabled && !I18n.publicPage ? 'en' : I18n.lang;
});